export const Logo = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="lla-logo">
    <circle cx="20" cy="20" r="19" stroke="#8C4A32" strokeWidth="1.5" strokeDasharray="2 2" />
    <path d="M14 28V12C14 12 21 12 21 17C21 22 14 22 14 22H26V28" stroke="#241E1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 22L27 28" stroke="#8C4A32" strokeWidth="2" strokeLinecap="round" />
    <circle cx="21" cy="17" r="2" fill="#8C4A32" />
  </svg>
);
